import {
  FileTextOutlined,
  ProfileOutlined,
  QuestionCircleOutlined,
  TeamOutlined,
  UserOutlined
} from '@ant-design/icons';
import React from 'react';

export const SideBarConfigInvestor = [
  {
    key: 0,
    title: 'Personal data',
    icon: <UserOutlined style={{ fontSize: '20px' }} />,
    href: ''
  },
  {
    key: 1,
    title: 'Questionnaires',
    icon: <QuestionCircleOutlined style={{ fontSize: '20px' }} />,
    href: 'questionnaires'
  },
  {
    key: 2,
    title: 'Documents',
    icon: <FileTextOutlined style={{ fontSize: '20px' }} />,
    href: 'documents'
  },
  {
    key: 3,
    title: 'Structure',
    icon: <TeamOutlined style={{ fontSize: '20px' }} />,
    href: 'referrals'
  },
  {
    key: 4,
    title: 'Products',
    icon: <ProfileOutlined style={{ fontSize: '20px' }} />,
    href: 'products'
  }
];

export const SideBarConfigReferral = [
  {
    key: 0,
    title: 'Questionnaires',
    icon: <QuestionCircleOutlined style={{ fontSize: '20px' }} />,
    href: 'questionnaires'
  },
  {
    key: 1,
    title: 'Documents',
    icon: <FileTextOutlined style={{ fontSize: '20px' }} />,
    href: 'documents'
  },
  {
    key: 2,
    title: 'Products',
    icon: <ProfileOutlined style={{ fontSize: '20px' }} />,
    href: 'products'
  }
];

export const SideBarConfigAdmin = [
  {
    title: 'User management',
    href: '/investors/PERSONAL',
    subpages: [
      { title: 'Individual clients', href: '/investors/PERSONAL' },
      { title: 'Legal entities', href: '/investors/COMPANY' }
    ]
  },
  {
    title: 'Localization',
    href: '/localization'
  },
  {
    title: 'Constructor (questionnaires)',
    href: '/constructorQuestionnaires'
  },
  {
    title: 'Constructor (documents)',
    href: '/constructorDocuments'
  },
  {
    title: 'Constructor (products)',
    href: '/constructorProducts'
  },
  {
    title: 'Constructor (scoring categories)',
    href: '/constructorScoringCategory'
  },
  {
    title: 'Statics',
    href: '/statics'
  },
  {
    title: 'Settings',
    href: '/settings'
  }
];

export const SideBarConfigSuperAdmin = [
  {
    title: 'User management',
    href: '/investors/PERSONAL',
    subpages: [
      { title: 'Individual clients', href: '/investors/PERSONAL' },
      { title: 'Legal entities', href: '/investors/COMPANY' }
    ]
  }
];

export const TabsInvestorAdmin = [
  {
    key: 0,
    label: 'Personal data',
    href: './'
  },
  {
    key: 1,
    label: 'Questionnaires',
    href: './questionnaires'
  },
  {
    key: 2,
    label: 'Documents',
    href: './documents'
  },
  {
    key: 3,
    label: 'Structure',
    href: './referrals'
  },
  {
    key: 4,
    label: 'Products',
    href: './products'
  },
  {
    key: 5,
    label: 'Activity',
    href: './activity'
  }
];

export const SelectTabsInvestorAdmin = [
  {
    value: 0,
    label: 'Personal data',
    href: './'
  },
  {
    value: 1,
    label: 'Questionnaires',
    href: './questionnaires'
  },
  {
    value: 2,
    label: 'Documents',
    href: './documents'
  },
  {
    value: 3,
    label: 'Structure',
    href: './referrals'
  },
  {
    value: 4,
    label: 'Products',
    href: './products'
  },
  {
    value: 5,
    label: 'Activity',
    href: './activity'
  }
];
